import React from "react";
import { BriefcaseIcon } from "@heroicons/react/24/outline";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import { getTimeSlotsDuration, formatHoursAndMinutes } from "../utils/workTimeCount";


const TabellaTurnoGiornaliero = ({ selectedWorkingHour }) => {
    const totalHours = getTimeSlotsDuration(selectedWorkingHour.time_slots || []);
    const totalWorkingTime = formatHoursAndMinutes(totalHours);

    
    return(
        <>
            <div className="col-span-6 my-4 flex justify-center">
                <table className="w-3/4 table-fixed border border-gray-200 rounded-lg shadow text-sm">
                    <thead className="bg-indigo-50 text-center">
                        <tr>
                            <th className="px-4 py-2 text-gray-600 w-1/2">
                                <BriefcaseIcon className="w-4 h-4 text-indigo-700 me-1 inline-block" /> Fascia Oraria
                            </th>
                            <th className="px-4 py-2 text-gray-600 w-1/2">
                                <LocalBarIcon style={{ height: '15px', width: '15px', color: '#4f46e5', marginRight: '4px' }} /> Pausa
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedWorkingHour.time_slots
                            .sort((a, b) => a.start_at.localeCompare(b.start_at))
                            .map((slot) => (
                                <tr key={slot.id}>
                                    <td className="border px-4 py-2 w-1/2 font-medium">
                                        {slot.start_at} - {slot.end_at}
                                    </td>
                                    <td className="border px-4 py-2 w-1/2">
                                        {slot.breaks.length > 0 ? (
                                            <div className="space-y-1">
                                                {slot.breaks.map((br) => (
                                                    <div key={br.id} className="flex items-center justify-center space-x-1 text-gray-600">
                                                        <span>{br.start_at} - {br.end_at}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <span className="text-gray-400">Nessuna</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <div className="text-gray-700 text-center text-sm font-semibold">
                Totale ore giornaliere: {totalWorkingTime}
            </div>
        </>
    )
};

export default TabellaTurnoGiornaliero;
